import { filter, withLatestFrom, map } from 'rxjs/operators';
import { combineLatest, merge } from 'rxjs';

const flattenStream = ([
    currentTime,
    [
        latestConfig,
        latestPlayback,
        latestPlayerPlayback,
    ],
]) => [
    currentTime,
    latestConfig,
    latestPlayback,
    latestPlayerPlayback,
];

const createResumePointsTriggerStream = (
    resumePointsInterval$,
    playbackSeek$,
    configStoreUpdate$,
    playbackUpdate$,
    playerPlaybackUpdate$,
) => {
    const configPlaybackAndPlayer$ = combineLatest(
        configStoreUpdate$,
        playbackUpdate$,
        playerPlaybackUpdate$,
    );

    return merge(
        resumePointsInterval$,
        playbackSeek$,
    )
        .pipe(
            filter(currentTime => currentTime > 0),
            withLatestFrom(configPlaybackAndPlayer$),
            map(flattenStream),
        );
};

export default createResumePointsTriggerStream;
